import React, { useEffect, useRef,useState,useMemo } from 'react';
import { GoogleMap, LoadScript, Marker,DirectionsRenderer,InfoWindow, DirectionsService,  } from '@react-google-maps/api';
import moment from 'moment-timezone';
const containerStyle = {
  width: '100%',
  height: '400px'
};
 
function MapComponent({ location }) {
  //const directionsService = new google.maps.DirectionsService();
  const originalLocation = { lat: 37.7749, lng: -122.4194 }; // San Francisco
  //const startLocation = { lat: 37.7839, lng: -122.4194 }; // 1 km North
  //const endLocation = { lat: 37.7749, lng: -122.4074 };
  // const startLocation = useMemo(() => ({
  //   lat: 37.7839 ,
  //   lng: -122.4194
  // }), []);

  // const endLocation = useMemo(() => ({
  //   lat:  37.7749,
  //   lng: -122.4074
  // }), []);
  const startLocation = useMemo(() => ({
    lat: parseFloat(location.trip.pickup_latitude),
    lng: parseFloat(location.trip.pickup_longitude)
  }), [location.trip.pickup_latitude, location.trip.pickup_longitude]);

  const endLocation = useMemo(() => ({
    lat: parseFloat(location.trip.dropoff_latitude),
    lng: parseFloat(location.trip.dropoff_longitude)
  }), [location.trip.dropoff_latitude, location.trip.dropoff_longitude]);
 const pickupTime = location.trip.pick_up_time;
 const dropOffTime = location.trip.drop_off_time;

  const [isLoaded, setIsLoaded] = useState(false);
  const directionsServiceRef = useRef(null);
  const directionsRendererRef = useRef(null);
  const mapRef = useRef(null);
  const [directionsResponse, setDirectionsResponse] = useState(null);
  const [selectedMode, setSelectedMode] = useState('DRIVING');
  const [infoWindow, setInfoWindow] = useState({ visible: false, position: null, content: '',title:'',time:'',subTitle:'' });
 
  //const endLocation = { lat: parseFloat(location.trip.dropoff_latitude), lng: parseFloat(location.trip.dropoff_longitude)}; // Ending location (Los Angeles)
  //const path = [startLocation, endLocation];
  // Define the polygon coordinates
  
  useEffect(() => {
    if (isLoaded && mapRef.current && directionsServiceRef.current && directionsRendererRef.current) {
      calculateAndDisplayRoute();
    }
  }, [isLoaded,startLocation, endLocation]);
  // const calculateAndDisplayRoute = () => {
  //   if (!window.google) {
  //     console.error('Google Maps JavaScript API not loaded');
  //     return;
  //   }

  //   const directionsService = new window.google.maps.DirectionsService();
  //   const request = {
  //     origin: startLocation,
  //     destination: endLocation,
  //     travelMode: window.google.maps.TravelMode.DRIVING,
  //   };

  //   directionsService.route(request, (result, status) => {
  //     if (status === window.google.maps.DirectionsStatus.OK) {
  //       const modifiedResult = { ...result };
  //       modifiedResult.routes[0].legs[0].start_address = 'Leg Start Location';
  //       modifiedResult.routes[0].legs[0].end_address = 'Leg End Location';
  //       setDirectionsResponse(result);
  //     } else {
  //       console.error('Directions request failed due to ' + status);
  //     }
  //   });
  // };
  const calculateAndDisplayRoute = async () => {
    if (!window.google) {
      console.error('Google Maps JavaScript API not loaded');
      return;
    }

    const directionsService = new window.google.maps.DirectionsService();
    const request = {
      origin: startLocation,
      destination: endLocation,
      travelMode: window.google.maps.TravelMode[selectedMode],
    };

    try {
      const result = await new Promise((resolve, reject) => {
        directionsService.route(request, (result, status) => {
          if (status === window.google.maps.DirectionsStatus.OK) {
            resolve(result);
          } else {
            reject('Directions request failed due to ' + status);
          }
        });
      });

      const modifiedResult = { ...result };
      //modifiedResult.routes[0].legs[0].start_address = 'Leg Start Location';
      //modifiedResult.routes[0].legs[0].end_address = 'Leg End Location';
      setDirectionsResponse(result);
    } catch (error) {
      console.error(error);
    }
  };
  const handleMapLoad = async (map) => {
    mapRef.current = map;
    directionsServiceRef.current = new window.google.maps.DirectionsService();
    directionsRendererRef.current = new window.google.maps.DirectionsRenderer();
   
    directionsRendererRef.current.setMap(map);
    setIsLoaded(true);
    await calculateAndDisplayRoute();
    
  };
  const handleMarkerClick = (position, content,title,time,subTitle) => {
    if (typeof position.lat === 'function') {
      position = { lat: position.lat(), lng: position.lng() };
    }
    setInfoWindow({ visible: true, position, content,title,time,subTitle });
  };

  const handleInfoWindowClose = () => {
    setInfoWindow({ visible: false, position: null, content: '' });
  };
  // {console.log("directionsResponse",infoWindow)}
  return (
    <LoadScript
    
      googleMapsApiKey="AIzaSyCzII2bsnbbxWr7O31YyG0Q1BOeWS_sjiI" // Replace with your API key
      onLoad={() => setIsLoaded(true)}
      onError={() => console.error('Error loading Google Maps JavaScript API')}
    >
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={startLocation} // Center the map on the starting location
        zoom={6}
        onLoad={handleMapLoad}
      >
        
         
         {directionsResponse && directionsResponse.routes && directionsResponse.routes[0] && (
            <>
              <Marker
                position={directionsResponse.routes[0].legs[0].start_location}
                
                onClick={() => handleMarkerClick(
                  directionsResponse.routes[0].legs[0].start_location, 
                  directionsResponse.routes[0].legs[0].start_address,
                  'Pickup Details',
                  directionsResponse.routes[0].legs[0].arrival_time ? directionsResponse.routes[0].legs[0].arrival_time.text : 'N/A',
                'PickUp Time')}
              />
              <Marker
                position={directionsResponse.routes[0].legs[0].end_location}
                
                onClick={() => handleMarkerClick(
                  directionsResponse.routes[0].legs[0].end_location, 
                  directionsResponse.routes[0].legs[0].end_address,
                  'Drop Off Details',
                  directionsResponse.routes[0].legs[0].arrival_time ? directionsResponse.routes[0].legs[0].arrival_time.text : 'N/A',
                'Drop Off Time')}
              />
              <DirectionsRenderer
                directions={directionsResponse}
                options={{
                  polylineOptions: {
                    strokeColor: '#00008B', // Dark blue color
                    strokeOpacity: 1.0,
                    strokeWeight: 5,
                  },
                  suppressMarkers: true, // Suppress default markers
                }}
              />
              {infoWindow.visible && (
                <InfoWindow
                  position={{ lat: infoWindow.position.lat, lng: infoWindow.position.lng }}
                  onCloseClick={handleInfoWindowClose}
                >
                  <div>
                    <div style={
                      {fontSize:'15px',
                      fontWeight:'bold',
                      textDecoration:'underline',
                      marginBottom:'6px'
                      }}>{infoWindow.title}</div>
                    <div>{infoWindow.content}</div>
                    {infoWindow.subTitle==='PickUp Time' ?
                      <div style={{colour:'#000'}}><span>{infoWindow.subTitle} : </span><span>{pickupTime ? moment(pickupTime, 'HH:mm:ss').format('hh:mm a'): 'N/A'}</span></div>
                      : <div style={{colour:'#000'}}><span>{infoWindow.subTitle} : </span><span>{dropOffTime ? moment(dropOffTime, 'HH:mm:ss').format('hh:mm a') : 'N/A' }</span></div>
                    }
                    </div>
                </InfoWindow>
              )}
            </>
          )}
        
      </GoogleMap>
    </LoadScript>
  );
}

export default MapComponent
